import {post, get, patch, put} from "./http";
import baseURL from "./base";

export default {
  patch(data) {
    return patch(`${baseURL}xxx`, data);
  },
  put(data) {
    return put(`${baseURL}xxx`, data);
  },
  post(data) {
    return post(`${baseURL}xxx`, data);
  },

  /* 验证码
  login register sendmsg bindmobile changepwd */
  captcha(data) {
    return get(`${baseURL.baseURL}captcha?type=${data}`);
  },
  /* 登录
  mobile 手机号
  password 密码
  code 图形验证码*/
  login(data) {
    return post(`${baseURL.baseURL}user/login`, data);
  },

  //   /user/loginstatus
  // loginstatus (data) {
  //     return post(`${baseURL.baseURL}user/loginstatus`, data);
  // },
  loginstatus(data) {
    return post(`${baseURL.baseURL}family/loginstatus`, data);
  },

  /* 注册
  /user/register
  mobile 手机号
  msgcode  手机验证码
  code  图形验证码
  familyName 姓
  givenName 名
  password 密码  */
  register(data) {
    return post(`${baseURL.baseURL}user/register`, data);
  },
  // 找回密码
  forgetpass(data) {
    return post(`${baseURL.baseURL}user/forgetpass`, data);
  },
  /*绑定新手机号
  /center/bindmobile
  mobile 手机号
  msgcode 手机验证码
  code 图形验证码
  password 密码
*/
  bindmobile(data) {
    return post(`${baseURL.baseURL}center/bindmobile`, data);
  },
  /* 修改密码
  /center/changepass
  mobile 手机号
  oldpass 老密码
  newpass 新密码
  code 图形验证码 */
  changepass(data) {
    return post(`${baseURL.baseURL}center/changepass`, data);
  },

  /* 发送短信
  /user/sendmsg
  mobile 手机号
  code 图形验证码
  type 类型 1为注册 2为找回密码 3为绑定新手机号 */
  sendmsg(data) {
    return post(`${baseURL.baseURL}user/sendmsg?mobile=${data.mobile}&code=${data.code}&type=${data.type}`);
  },

  /* 忘记密码
  user/forget
  mobile 手机号
  code 图形验证码
  msgcode  手机验证码
  password 密码 */
  forget(data) {
    return post(`${baseURL.baseURL}center/forget`, data);
  },

  /* 获取当前信息 */
  myinfo(data) {
    return post(`${baseURL.baseURL}user/myinfo`, data);
  },
  /* 编辑个人信息 */
  myinfoupdate(data) {
    return post(`${baseURL.baseURL}user/myinfoupdate`, data);
  },

  // 添加配偶
  spouseAdd(data) {
    return post(`${baseURL.baseURL}spouse/add`, data);
  },
  // 编辑配偶
  spouseEdit(data) {
    return post(`${baseURL.baseURL}spouse/edit`, data);
  },
  // 删除配偶
  spouseDel(data) {
    return post(`${baseURL.baseURL}spouse/del`, data);
  },
  // 配偶列表
  spouseList(data) {
    return post(`${baseURL.baseURL}spouse/list?fid=` + data);
  },

  // 编辑迁移
  migrationEdit(data) {
    return post(`${baseURL.baseURL}migration/edit`, data);
  },

  // /api/family/getchat
  familyGetchat(data) {
    return post(`${baseURL.baseURL}family/getchat?fid=` + data);
  },
  // 设置观察员或管理员权限
  changeauthority(data) {
    return post(`${baseURL.baseURL}family/switchidentity?fid=${data.fid}&type=${data.type}`);
  },
  //获取本人所有家谱
  familyList(data) {
    return post(`${baseURL.baseURL}family/list`, data);
  },
  // 获取家谱信息
  familyGet(data) {
    return post(`${baseURL.baseURL}family/get?fid=` + data);
  },
  // 添加家谱
  familyAdd(data) {
    return post(`${baseURL.baseURL}family/add`, data);
  },
  // 编辑家谱
  familyEdit(data) {
    return post(`${baseURL.baseURL}family/edit`, data);
  },
  // 删除家谱
  //判断
  familyDelFlag(data){
    return post(`${baseURL.baseURL}family/checkOwner?fid=` + data);
  },
  sendDelMsg(data) {
    // return post(`${baseURL.baseURL}user/sendmsg`,data);
    return post(`${baseURL.baseURL}user/sendmsg?fid=${data.fid}&code=${data.code}&type=${data.type}`);
  },
  familyDel(data) {
    return post(`${baseURL.baseURL}family/del?fid=`+data.id);
  },
  // 查看权限
  permissionlist(data) {
    return get(`${baseURL.baseURL}permission/permissionlist`, data);
  },

  /*
      添加接口
https://fm.9itsg.net/api/permission/permissionadd?fid=家谱ID&mobile=用户手机号&mid=分支祖先id&level=等级(0,1,2)
  */
  permissionadd(data) {
    return get(`${baseURL.baseURL}permission/permissionadd`, data);
  },
  // 删除权限
  permissiondel(data) {
    return get(`${baseURL.baseURL}permission/permissiondel`, data);
  },
  //编辑权限
  permissionupdate(data) {
    return get(`${baseURL.baseURL}permission/permissionupdate`, data);
  },
  selectbymobile(data) {
    return post(`${baseURL.baseURL}family/selectbymobile?mobile=` + data);
  },
  // 家谱所有人员树状图
  listtreename(data) {
    return get(`${baseURL.baseURL}member/listtreename`, data);
  },
  // 家谱所有人员树状图
  listsxtreename(data) {
    return post(`${baseURL.baseURL}chapter/getsxtree?id=` + data);
  },
  ///?fid=11
  //以树状结构展示所有成员  参数fid 家谱id
  memberListtree(fid,type) {
    return post(`${baseURL.baseURL}member/listtree?fid=` + fid + `&type=` + type);
  },
  // /api/member/add 添加人员 参数是Member类 返回值是主键id
  memberAdd(data) {
    return post(`${baseURL.baseURL}member/add`, data);
  },
  // /api/member/edit 编辑人员 参数是Member类 无返回值
  memberEdit(data) {
    return post(`${baseURL.baseURL}member/edit`, data);
  },
  // /api/member/del 删除人员 参数mid 人员id
  memberDel(data) {
    return post(`${baseURL.baseURL}member/del?mid=` + data);
  },
  // /api/member/list 展示所有成员 参数fid 家谱id
  memberList(data) {
    return post(`${baseURL.baseURL}member/list?fid=` + data);
  },
  // /api/member/get 获取成员信息 参数mid 人员id
  memberGet(data) {
    return post(`${baseURL.baseURL}member/get?mid=` + data);
  },

  // type 1国内  2国外
  // 获取省
  getSheng(data) {
    return post(`${baseURL.baseURL}zone/getsheng?type=` + data);
  },
  // 获取市
  getShi(data) {
    return post(`${baseURL.baseURL}zone/getshi?type=` + data.type + `&shengid=` + data.id);
  },
  getXian(data) {
    return post(`${baseURL.baseURL}zone/getxian?shiid=` + data);
  },
  getCoordinate(data) {
    return post(`${baseURL.baseURL}zone/getcoordinate`, data);
  },

  // 一键寻租
  memberFindancestor(data) {
    return post(`${baseURL.baseURL}member/findancestor`, data);
  },

  // 查询共祖
  memberFindbothancestor(data) {
    return post(`${baseURL.baseURL}member/findbothancestor`,
      data);
  },

  // 迁移
  migrationMigrateto(data) {
    return post(`${baseURL.baseURL}migration/migrateto?fid=` +
      data);
  },
  migrateToByName(data) {
    return post(`${baseURL.baseURL}migration/migrateToByName?fid=` + data.id + '&type=' + data.type);
  },

  //九族五服图
  memberFivefu(data) {
    return post(`${baseURL.baseURL}member/fivefu`, data);
  },

  //九族五服图搜索
  memberFivefubyname(data) {
    return post(`${baseURL.baseURL}member/fivefubyname`, data);
  },
  // 上传头像
  /*
      fid 家谱id
      mid 成员id
      img 图片的base64
  */
  uploadAvator(data) {
    return post(`${baseURL.baseURL}upload/uploadAvator`, data);
  },

  //   api/member/delavator
  delAvator(data) {
    return post(`${baseURL.baseURL}member/delavator`, data);
  },
  // 获取个人信息
  getmyinfo(data) {
    return post(`${baseURL.baseURL}member/getancestorsinfo?fid=` + data);
  },

  // 家族分布图始祖位置  api/area/getancestorarea
  getancestorarea(data) {
    return post(`${baseURL.baseURL}area/ancestorarea?fid=` + data);
  },
  // 家族分布图成员位置  api/area/familyarea
  familyarea(data) {
    return post(`${baseURL.baseURL}area/familyarea?fid=` + data);
  },
  // 获取所有朝代
  getchaodai(data) {
    return post(`${baseURL.baseURL}dynasty/getchaodai`, data);
  },
  // 获取本朝代所有年号
  getnianhaobychaodai(data) {
    return post(`${baseURL.baseURL}dynasty/getnianhaobychaodai `, data);
  },
  // 传值 year  通过公元年获取朝代和年号
  getbyyear(data) {
    return post(`${baseURL.baseURL}dynasty/getbyyear `, data);
  },
  // 传值 chaodai  nianhao  通过朝代和年号获取公元年
  getyearbychaodainianhao(data) {
    return post(`${baseURL.baseURL}dynasty/getyearbychaodainianhao `, data);
  },
  // 获取所有公元年
  getyear(data) {
    return post(`${baseURL.baseURL}dynasty/getyear `, data);
  },

  //列出本家谱下的所有谱书
  bookList(data) {
    return post(`${baseURL.baseURL}book/list?fid=` + data);
  },
  //列出本家谱下的所有谱书
  bookPdf(data) {
    return post(`${baseURL.baseURL}book/getbook?id=` + data);
  },
  // 添加谱书
  bookAdd(data) {
    return post(`${baseURL.baseURL}book/add`, data);
  },
  // 编辑谱书
  // 删除谱书   参数 id 谱书ID
  bookEdit(data) {
    return post(`${baseURL.baseURL}book/edit`, data);
  },
  bookDel(data) {
    return post(`${baseURL.baseURL}book/del`, data);
  },

  // chapter/getinfo
  getInfo(data) {
    return post(`${baseURL.baseURL}chapter/getinfo`, data);
  },

  // 参数bid 谱书ID 列出本谱书的所有章节
  chapterList(data) {
    return post(`${baseURL.baseURL}chapter/list`, data);
  },
  // 参数chapter类   编辑本谱书的章节
  chapterEdit(data) {
    return post(`${baseURL.baseURL}chapter/edit`, data);
  },
  //参数chapter类   添加本谱书的章节
  chapterAdd(data) {
    return post(`${baseURL.baseURL}chapter/add`, data);
  },
  // 参数id 谱书章节的id   删除本谱书的章节
  chapterDel(data) {
    return post(`${baseURL.baseURL}chapter/del`, data);
  },
  // 参数id 谱书章节的id 获取章节的内容 包括全文的内容
  chapterGet(data) {
    return post(`${baseURL.baseURL}chapter/get`, data);
  },
  //参数mid 人员id 获取人员的信息内容
  memberGetinfo(data) {
    return post(`${baseURL.baseURL}member/getinfo`, data);
  },
  // 入谱人数统计表
  ///api/analysis/inputFamily?fid=11
  inputFamily(data) {
    return get(`${baseURL.baseURL}analysis/inputFamily`, data);
  },
  ///api/analysis/seniority?fid=11
  // 人员辈分表
  seniority(data) {
    return get(`${baseURL.baseURL}analysis/seniority`, data);
  },
  //https://fm.9itsg.net/api/analysis/education?fid=11
  // 人员学历

  education(data) {
    return get(`${baseURL.baseURL}analysis/education`, data);
  },
  //行政职务 https://fm.9itsg.net/api/analysis/position?fid=11
  position(data) {
    return get(`${baseURL.baseURL}analysis/position`, data);
  },

  //职称 https://fm.9itsg.net/api/analysis/jobtitle?fid=11
  jobtitle(data) {
    return get(`${baseURL.baseURL}analysis/jobtitle`, data);
  },
  //军职 https://fm.9itsg.net/api/analysis/military?fid=11
  military(data) {
    return get(`${baseURL.baseURL}analysis/military`, data);
  },
  //迁徙 https://fm.9itsg.net/api/analysis/migration?fid=11
  migration(data) {
    return get(`${baseURL.baseURL}analysis/migration`, data);
  },
  //辈分 https://fm.9itsg.net/api/analysis/generational ?fid=11
  generational(data) {
    return get(`${baseURL.baseURL}analysis/generational`, data);
  },
  //出生 https://fm.9itsg.net/api/analysis/born?fid=11
  born(data) {
    return get(`${baseURL.baseURL}analysis/born`, data);
  },
  //世人员分布统计表 https://fm.9itsg.net/api/analysis/regionalDistribution?fid=11
  regionalDistribution(data) {
    return get(`${baseURL.baseURL}analysis/regionalDistribution`, data);
  },

  // 设置默认家谱
  setDefaultFamily(data) {
    return post(`${baseURL.baseURL}family/set_default_family?fid=` + data);
  },
  // 获取默认家谱
  getDefaultFamily(data) {
    return post(`${baseURL.baseURL}family/get_default_family?`, data);
  },

  // 日历转换
  convertdate(data) {
    return post(`${baseURL.baseURL}member/convertdate`, data);
  },

  //  获取属相
  zodiac(data) {
    return post(`${baseURL.baseURL}member/zodiac`, data);
  },

  // 查重名
  findbyname(data) {
    return post(`${baseURL.baseURL}member/findbyname`, data);
  },

  // 合理验证
  verifyMemberInfo(data) {
    return post(`${baseURL.baseURL}member/verifyMemberInfo`, data);
  },
  // 获取汇总资料
  getzlhz(data) {
    return post(`${baseURL.baseURL}member/getzlhz`, data);
  },
  // 更新汇总资料
  updatezlhz(data) {
    return post(`${baseURL.baseURL}member/updatezlhz`, data);
  },
  getzlhzByMember(data) {
    return post(`${baseURL.baseURL}member/getZlhzByMember`, data);
  },
  getpermission(data) {
    return post(`${baseURL.baseURL}family/getpermission?fid=`+data);
  },
  getnews(data) {
    return post(`${baseURL.baseURL}news/list?type=` + data.type + "&page=" + data.page + "&limit=" + data.limit + "&fid=" + data.fid);
  },
  // 新闻详情
  newsDetail(data) {
    return post(`${baseURL.baseURL}news/detail?id=` + data.id + "&fid=" + data.fid);
  },
  // 新增新闻
  newsAdd(data) {
    return post(`${baseURL.baseURL}news/add`, data);
  },
  // 修改新闻
  newsUpdate(data) {
    return post(`${baseURL.baseURL}news/update`, data);
  },
  // 删除新闻
  newsDelete(data) {
    return post(`${baseURL.baseURL}news/delete?id=` + data.id + "&fid=" + data.fid);
  },
  // 退出
  logout(data) {
    return post(`${baseURL.baseURL}user/logout`, data);
  },
};



// WEBPACK FOOTER //
// ./src/request/api.js